// Angular Import
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule, Event, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

// project import
import { NavigationItem } from '../../types/navigation';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { menus } from 'src/app/demo/data/menu';
import { componentMenus } from 'src/app/demo/data/component';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from '../../services/theme-layout.service';
import { RTL } from '../../const';
import { TabSystemMenuService } from 'src/app/tabms/services/menu/tab-system-menu.service';
import { Subject, takeUntil } from 'rxjs';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';

interface titleType {
  // eslint-disable-next-line
  url: string | boolean | any | undefined;
  title: string;
  breadcrumbs: unknown;
  type: string;
  link: string | undefined;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, SharedModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  // public props
  @Input() type: string;
  @Input() Component = false;
  @Input() dashboard = true;

  navigations: NavigationItem[];
  ComponentNavigations: NavigationItem[];
  breadcrumbList: Array<string> = [];
  navigationList: titleType[];
  componentList: titleType[];
  currentLang
  activeLink

  private destroy$: Subject<void> = new Subject<void>();

  // constructor
  constructor(
    private route: Router,
    private titleService: Title,
    private translate: TranslateService,
    private themeLayout: ThemeLayoutService,
    private tabSystem: TabSystemMenuService
  ) {
    // this.navigations = menus;
    this.ComponentNavigations = componentMenus;
    this.type = 'theme1';
    // console.log('in constructor');
    //intialize menu
    this.tabSystem.menuCompleted.pipe(takeUntil(this.destroy$)).subscribe((success) => {
      if (success) {
        this.navigations = this.tabSystem.menusfromDB
        // console.log('this.navigations:', this.navigations);
      }
      else {
        this.navigations = [];
        // console.log('this.navigationselse:', this.navigations);
      }
      this.setBreadcrumb(); // initial call
    });
    //end region

    //get active link
    this.activeLink = this.route.url; // get current url
    // console.log('Active Linkintialconstructor:', this.activeLink);

    this.route.events.pipe(takeUntil(this.destroy$)).subscribe((router: Event) => {
      if (router instanceof NavigationEnd) {
        this.activeLink = router.url; // update url if navigation changed
        // console.log('Active Linkonchange:', this.activeLink);
        this.setBreadcrumb(); // update on navigation change
      }
    });
    //end region

    //set title on language change
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setBreadcrumb(); // update on lang change
    });

    this.themeLayout.directionChange.pipe(takeUntil(this.destroy$)).subscribe((dir) => {
      this.currentLang = dir === RTL ? 'ar' : 'en';
      this.translate.use(this.currentLang);  //update current language
      this.setBreadcrumb(); // update on direction change
    });

    //end region
  }

  // public method
  setBreadcrumb() {
    const breadcrumbList = this.filterNavigation(this.navigations, this.activeLink);
    this.navigationList = breadcrumbList;
    // this.componentList = this.filterNavigation(this.ComponentNavigations, activeLink);
    const title = breadcrumbList[breadcrumbList.length - 1]?.title || 'Welcome';
    this.translate.get(title).pipe(takeUntil(this.destroy$)).subscribe((translatedTitle) => {
      this.titleService.setTitle(translatedTitle + ' | TabHRMS');
    });
  }

  filterNavigation(navItems: NavigationItem[], activeLink: string): titleType[] {
    // console.log('Checking Nav Item:', navItems);
    if (navItems) {
      for (const navItem of navItems) {
        // console.log('Checking Nav Item:', navItem);
        if (navItem.type === 'item' && 'url' in navItem) {
          const cleanedActiveLink = activeLink
          const cleanedUrl = navItem.url.startsWith('/') ? navItem.url : `/${navItem.url}`;
          const dynamicUrlPattern = new RegExp(`^${cleanedUrl}$`);
          const isMatch = dynamicUrlPattern.test(cleanedActiveLink);
          // console.log(`Checking: activeLink = ${cleanedActiveLink}, navItem.url = ${cleanedUrl}, isMatch = ${isMatch}`);
          if (isMatch) {
            return [
              {
                url: navItem.url,
                title: navItem.title,
                link: navItem.link,
                breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
                type: navItem.type
              }
            ];
          }
        }

        if ((navItem.type === 'group' || navItem.type === 'collapse') && 'children' in navItem && navItem.children.length > 0) {
          const breadcrumbList = this.filterNavigation(navItem.children, activeLink);
          if (breadcrumbList.length > 0) {
            breadcrumbList.unshift({
              url: 'url' in navItem ? navItem.url : false,
              title: navItem.title,
              link: navItem.link,
              breadcrumbs: 'breadcrumbs' in navItem ? navItem.breadcrumbs : true,
              type: navItem.type
            });
            return breadcrumbList;
          }
        }
      }
    }
    return [];
  }

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  //end region
}
